/**************
 Cart
 ***************/

// A/B Test Guard: only initialize when simple cart is active
if (!window.__cartVariant || window.__cartVariant === 'simple') {

// open cart
async function openCart(skipFetch = false) {
    // open cart
    if (document.querySelector("#miniCart:not([open])")) {
        document.querySelector("#miniCart").showModal();
    }
    document.querySelector("body").classList.add("noScroll");

    // hide all sections
    document.querySelector("#miniCartEmpty").classList.remove("active");
    document.querySelector("#miniCartHeader").classList.remove("active");
    document.querySelector("#miniCartAnnouncement")?.classList.remove("active");
    document.querySelector("#miniCartBody").classList.remove("active");
    document.querySelector("#miniCartUpsell").classList.remove("active");
    document.querySelector("#miniCartFooter").classList.remove("active");

    // start loading on the cart
    document.querySelector("#miniCartContent").classList.add("loading");

    // fetch cart
    if (skipFetch === false) {
        cart = await getCart();
    }

    // get cart item data
    const cartData = await fetch("/cart?view=supplemental-data")
        .then(response => response.json());

    /*************************
     Start Free Items
     **************************/

        // create update payload
    let updatePayload = {};

    // remove free gift items if in cart
    const freeGifts = cart?.items?.filter(item =>
        (item.handle === "water-bottle-mvp" || item.handle === "3-pack-variety-pack")
        // keep the GWP bottle (matched by its configured variant id) so it isn't stripped on render
        && !(item.id === window.gwpBottle?.variantId)
    );
    if (freeGifts?.length > 0) {
        // get all protection items
        freeGifts.forEach(item => {
            updatePayload[item.key] = 0;
        });
    }

    // GWP bottle: subscription cases currently in the cart (drives the add decision below).
    // Removal is handled in updateCartItem() so it only fires on a deliberate quantity change.
    const gwpMinCases = window.gwpBottle?.minCases || 2;
    const gwpSubscriptionCases = (cart?.items || []).reduce((sum, item) =>
        window.gwpCountsToward(item) ? sum + item.quantity : sum, 0);

    // check if we need to update the cart
    if (Object.keys(updatePayload).length > 0) {
        cart = await updateCart({updates: updatePayload});
        await openCart(true);
        return;
    }

    // GWP bottle: add it if the cart now qualifies (e.g. quantity was bumped in the drawer) and it isn't already there
    if (window.gwpBottle?.enabled && window.gwpBottle.variantId && gwpSubscriptionCases >= gwpMinCases) {
        const hasGwp = cart.items.some(item => item.id === window.gwpBottle.variantId);
        if (!hasGwp) {
            await addProduct({items: [{
                id: window.gwpBottle.variantId,
                quantity: 1,
                properties: {"_promo": "new subscription"}
            }]});
            await openCart();
            return;
        }
    }

    let variety30PackCount = 0;
    let variety30hasSubscription = false;

    // determine total number of premium-electrolyte-drink-mix
    let premiumElectrolyteDrinkMixCount = 0;
    let hasSubscription = false;
    cart.items.forEach(item => {
        if (window.giftCountsAsBox ? window.giftCountsAsBox(item) : item.handle === "premium-electrolyte-drink-mix") {
            premiumElectrolyteDrinkMixCount += item.quantity;
        }
        if (item.selling_plan_allocation) {
            hasSubscription = true;
        }
        if (item.handle === "variety-pack-30ct"  && window.enabledPack30) {
            variety30PackCount += item.quantity;
            if (item.selling_plan_allocation) {
                variety30hasSubscription = true;
            } 
        }
    });

    // hide all free gifts
    document.querySelectorAll(".miniCartBodyItem.gift").forEach(element => element.classList.remove("active"));

    // if 4 or more, add all gifts, if one sub, add sampler
    if (premiumElectrolyteDrinkMixCount >= 4) {
        document.querySelector("#miniCartBodyGiftSampler").classList.add("active");
        if (bottle) {
            document.querySelector("#miniCartBodyGiftWaterBottle").classList.add("active");
        }
    } else if (premiumElectrolyteDrinkMixCount >= 1 && hasSubscription) {
        document.querySelector("#miniCartBodyGiftSampler").classList.add("active");
    } else if (variety30PackCount >= 1 && variety30hasSubscription  && window.enabledPack30) {
        document.querySelector("#miniCartBodyGiftSampler").classList.add("active");
    }

    /*************************
     Finish Free Items
     **************************/

    // stop loading on the cart
    document.querySelector("#miniCartContent").classList.remove("loading");

    //  update cart count in header nav
    if (cart.item_count !== 0) {
        let count = cart.item_count;
        if(variety30hasSubscription  && window.enabledPack30){
            count++;
        }
        document.querySelector('#headerCartNumber').textContent = count < 10 ? "0" + count.toString() : count.toString();
        document.querySelector("#miniCartHeaderTitle").textContent = `Your Cart`;
    }

    // check for empty cart and EXIT
    if (cart.item_count === 0) {
        document.querySelector("#miniCartEmpty").classList.add("active");
        document.querySelector("#miniCartHeader").classList.add("active");
        document.querySelector('#headerCartNumber').textContent = "0";
        return;
    }

    // show main cart sections
    document.querySelector("#miniCartHeader").classList.add("active");
    document.querySelector("#miniCartAnnouncement")?.classList.add("active");
    document.querySelector("#miniCartBody").classList.add("active");
    document.querySelector("#miniCartUpsell").classList.add("active");
    document.querySelector("#miniCartFooter").classList.add("active");

    // reset body container
    document.querySelectorAll(".miniCartBodyItem:not(.gift)").forEach(element => element.remove());

    // footer compare-at total: sum of each line's comparePrice (or final line price if none),
    // so the footer matches the per-line strikethroughs.
    let cartCompareTotal = 0;

    // append cart
    cart.items.forEach(function (item) {

        // variant HTML
        function variantHTML() {
            // check for default variant
            if (item.variant_title === null) {
                return "";
            }

            return `<div class="miniCartBodyItemVariant ih:text-xs ih:text-black ih:mt-0.5">${item.variant_title}</div>`;
        }

        // property HTML
        const hasProperties = item.properties && Object.keys(item.properties).length > 0;

        function propertiesHTML() {
            // check for any properties
            if (!hasProperties) {
                return "";
            }

            // generate HTML for each item
            let HTML = `<div class="miniCartBodyItemProperties ih:text-xs ih:text-neutral-500 ih:mt-0.5">`;
            for (const key in item.properties) {
                // skip hidden properties (Shopify convention: keys starting with _ are hidden)
                if (key.startsWith("_")) continue;

                // check for link
                if (typeof item.properties[key] === "string" && item.properties[key].includes("https://")) {
                    HTML += `<a href="${item.properties[key]}" target="_blank">${item.properties[key]}</a><br>`;
                    continue;
                }

                // catch all
                HTML += `${key}: ${item.properties[key]}<br>`;
            }
            HTML += `</div>`;

            // return string
            return HTML;
        }

        // subscription HTML
        function subscriptionHTML() {
            if (item.selling_plan_allocation) {
                return `<div class="miniCartBodyItemSellingPlan ih:flex ih:items-center ih:gap-1 ih:text-[11px] ih:font-medium ih:text-neutral-600 ih:mt-1">
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M1 4v6h6M23 20v-6h-6"/><path d="M20.49 9A9 9 0 005.64 5.64L1 10m22 4l-4.64 4.36A9 9 0 013.51 15"/></svg>
                    ${item.selling_plan_allocation.selling_plan.name}
                </div>`;
            }
            return "";
        }

        // price HTML
        function priceHTML() {
            let HTML = "";

            /****************** discount ******************/

            let comparePrice = null;
            const compareCandidates = [];
            // subscription compare_at_price (per unit) * quantity
            if (item.selling_plan_allocation?.compare_at_price) {
                compareCandidates.push(item.selling_plan_allocation.compare_at_price * item.quantity);
            }
            // Shopify admin compare-at price (per unit) * quantity
            if (cartData[item.key]?.compare_at_price) {
                compareCandidates.push(cartData[item.key].compare_at_price * item.quantity);
            }
            // line item discount (pre-discount line price)
            if (item.original_line_price > item.final_line_price) {
                compareCandidates.push(item.original_line_price);
            }
            const highestCompare = Math.max(0, ...compareCandidates);
            if (highestCompare > item.final_line_price) {
                comparePrice = highestCompare;
            }

            // add to footer total; free lines keep their badge but are excluded from the math.
            if (item.final_line_price !== 0) {
                cartCompareTotal += comparePrice || item.final_line_price;
            }

            /****************** price row (current + strikethrough inline) ******************/

            HTML += `<div class="ih:inline-flex ih:items-baseline ih:gap-1.5">`;
            if (comparePrice) {
                HTML += `<s class="ih:text-xs ih:text-neutral-400 ih:line-through ih:font-normal">${price(comparePrice, false)}</s>`;
            }
            const gwpFree = item.id === window.gwpBottle?.variantId && item.final_line_price === 0;
            HTML += `<span class="ih:text-base ih:font-bold ih:text-black">${gwpFree ? 'FREE' : price(item.final_line_price, false)}</span>`;
            HTML += `</div>`;

            /***************** savings *****************/

            // check for savings
            if (comparePrice) {
                let savings = comparePrice - item.final_line_price;
                if (savings > 0) {
                    HTML += `<span class="ih:inline-flex ih:items-center ih:gap-1 ih:mt-1 ih:px-2 ih:py-0.5 ih:rounded-md ih:bg-green-600/10 ih:border ih:border-green-600/20 ih:text-[11px] ih:font-semibold ih:text-green-700 ih:whitespace-nowrap">Save ${price(savings, false)}</span>`;
                }
            }

            return HTML;
        }

        // check if item is a free gift
        const freeGiftItem = item.final_line_price === 0;

        // GWP gift line — lock the controls only while it's the free ($0) gift
        const isGwpItem = item.id === window.gwpBottle?.variantId && freeGiftItem;

        // upgrade button HTML
        function upgradeHTML() {
            // check if already a subscription
            if (item.selling_plan_allocation) {
                return "";
            }

            // check if it's a free gift
            if (freeGiftItem) {
                return "";
            }

            // get selling plan id and name
            let sellingPlanID = null;
            if (cartData[item.key]) {
                sellingPlanID = cartData[item.key].selling_plan_id;
            }

            // check if selling plan exists
            if (!sellingPlanID) {
                return "";
            }

            // return HTML
            return `
                <button type="button"
                    class="miniCartBodyItemUpgrade button"
                    data-key="${item.key}"
                    data-id="${item.variant_id}"
                    data-plan="${sellingPlanID}"
                    data-quantity="${item.quantity}">
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M1 4v6h6M23 20v-6h-6"/><path d="M20.49 9A9 9 0 005.64 5.64L1 10m22 4l-4.64 4.36A9 9 0 013.51 15"/></svg>
                    Subscribe &amp; Save an Extra 40%
                </button>
            `;
        }

        // check for alternate image
        let imageSource = item.image;
        if (cartData[item.key] && cartData[item.key].image) {
            imageSource = cartData[item.key].image;
        }

        // create quantity element so it can be disabled for free products
        function quantityElement() {
            if (freeGiftItem) {
                return `
                    <div class="miniCartBodyItemQuantityCount noChange ih:flex ih:items-center ih:justify-center ih:h-7 ih:px-2 ih:text-sm ih:font-bold ih:text-black">${item.quantity}</div>
                `;
            }

            return `
                <button class="miniCartBodyItemQuantityMinus ih:flex ih:items-center ih:justify-center ih:text-base ih:text-neutral-500 ih:hover:text-black ih:transition-colors">−</button>
                <div class="miniCartBodyItemQuantityCount ih:flex ih:items-center ih:justify-center ih:min-w-6 ih:h-8 ih:text-sm ih:font-bold ih:text-black">${item.quantity}</div>
                <button class="miniCartBodyItemQuantityPlus ih:flex ih:items-center ih:justify-center ih:text-base ih:text-neutral-500 ih:hover:text-black ih:transition-colors">+</button>
            `;
        }

        // create delete element so it can be disabled for free products
        function deleteElement() {
            if (freeGiftItem) return '';
            return `
                <button type="button" aria-label="Remove item" class="miniCartBodyItemRemove${isGwpItem ? ' gwp-locked' : ''}">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M3 6h18M8 6V4a2 2 0 012-2h4a2 2 0 012 2v2m3 0v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6h14z"/></svg>
                </button>
            `
        }

        // insert item
        document.querySelector("#miniCartBody").insertAdjacentHTML("beforeend", `
            <div class="miniCartBodyItem ih:relative ih:flex ih:flex-col ih:gap-3 ih:px-4 ih:py-5 ih:border-b ih:border-neutral-100 ih:transition-colors ih:hover:bg-neutral-50/60" key="${item.key}">
                <div class="ih:flex ih:gap-4">
                    <img class="miniCartBodyItemImage ih:w-16! ih:h-16! ih:max-[374px]:w-14! ih:max-[374px]:h-14! ih:rounded-xl ih:object-cover ih:border ih:border-neutral-100 ih:flex-shrink-0" src="${imageSource}&width=200" alt="${item.title}">
                    <div class="ih:flex-1 ih:min-w-0">
                        <div class="miniCartBodyItemTitle ih:text-[15px] ih:font-bold ih:text-black ih:leading-tight">${item.product_title}</div>
                        ${variantHTML()}
                        ${propertiesHTML()}
                        ${subscriptionHTML()}
                        <div class="miniCartBodyItemQuantity ih:inline-flex ih:items-center ih:gap-1 ih:mt-2 ih:px-2 ih:border ih:border-neutral-300 ih:rounded-full ih:bg-white${isGwpItem ? ' gwp-locked' : ''}">
                            ${quantityElement()}
                        </div>
                    </div>
                    <div class="miniCartBodyItemPrice ih:flex ih:flex-col ih:items-end ih:flex-shrink-0 ih:gap-1 ih:pt-1">${priceHTML()}</div>
                </div>
                ${upgradeHTML()}
                ${deleteElement()}
            </div>
        `);

    });

    // event listener for each line item
    document.querySelectorAll(`.miniCartBodyItem`).forEach(function (element) {
        // get key
        let key = element.getAttribute("key");

        // get current quantity
        let quantity = parseInt(element.querySelector(".miniCartBodyItemQuantityCount")?.textContent);

        // minus
        element.querySelector(".miniCartBodyItemQuantityMinus")?.addEventListener("click", function () {
            // prevents loading issues when too many clicks
            this.parentElement.classList.add('disable');
            if (quantity <= 0) return;
            if (quantity === 1) {
                element.querySelector(".miniCartBodyItemRemove").click();
            } else {
                quantity--;
                updateCartItem();
            }
        });

        // plus
        element.querySelector(".miniCartBodyItemQuantityPlus")?.addEventListener("click", function () {
            this.parentElement.classList.add('disable');
            quantity++;
            updateCartItem();
        });

        // remove
        element.querySelector(".miniCartBodyItemRemove")?.addEventListener("click", function () {
            this.parentElement.classList.add('disable');
            quantity = 0;
            updateCartItem();

            // fade out and remove
            element.classList.add("fade");
            setTimeout(() => {
                element.remove();
            }, 500);
        });

        // update quantity function
        async function updateCartItem() {
            // update label
            element.querySelector(`.miniCartBodyItemQuantityCount`).textContent = quantity;

            // prevent other items updating
            preventMultipleActions();

            // GWP: subscription cases BEFORE this change (to detect dropping below the threshold)
            const gwpMin = window.gwpBottle?.minCases || 2;
            const prevCases = (cart?.items || []).reduce((sum, it) =>
                window.gwpCountsToward(it) ? sum + it.quantity : sum, 0);

            // update cart in shopify
            cart = await changeCart({
                id: key,
                quantity: quantity
            });

            // subscription cases AFTER this change
            const newCases = (cart?.items || []).reduce((sum, it) =>
                window.gwpCountsToward(it) ? sum + it.quantity : sum, 0);

            // only remove a gift bottle when the cart drops FROM qualifying TO below the minimum.
            // a bottle in a cart that never qualified (i.e. a paid one) is left alone.
            if (prevCases >= gwpMin && newCases < gwpMin) {
                const gwpLine = (cart?.items || []).find(it => it.id === window.gwpBottle?.variantId);
                if (gwpLine) {
                    cart = await updateCart({updates: {[gwpLine.key]: gwpLine.quantity - 1}});
                }
            }

            // update active body
            await openCart(true);
        }

        // listen for upgrade button click
        element.querySelector(".miniCartBodyItemUpgrade")?.addEventListener("click", async function () {
            const key = this.dataset.key;
            const variantID = parseInt(this.dataset.id);
            const sellingPlanID = parseInt(this.dataset.plan);
            const quantity = parseInt(this.dataset.quantity);

            // add loading animation
            this.classList.add("loading");

            // prevent other items updating
            preventMultipleActions();

            // remove this product from the cart
            await changeCart({
                id: key,
                quantity: 0,
            });

            // add new product to cart (note, we don't change since we have a custom atc function)
            await addProduct({
                items: [{
                    quantity: quantity,
                    id: variantID,
                    selling_plan: sellingPlanID
                }]
            });

            await openCart();

            // remove loading animation
            this.classList.remove("loading");
        });
    });

    // check if cart contains an upsell item
    document.querySelectorAll(".miniCartUpsellItem")?.forEach(element => {
        // get the product id
        let productID = parseInt(element.dataset.product);

        // check if product exists within the cart
        let isProductInCart = cart.items.find(item => item.product_id === productID);

        // hide if already in the cart
        if (isProductInCart) {
            element.classList.remove("active");
        } else {
            element.classList.add("active");
        }
    });

    // check if all upsells are hidden
    if (document.querySelectorAll(".miniCartUpsellItem.active").length === 0) {
        document.querySelector("#miniCartUpsell")?.classList.remove("active");
    }

    // update price — real amount charged (cart-level discounts applied), not cart.total_price
    const checkoutPrice = checkoutTotal(cart);
    document.querySelector("#miniCartFooterCheckoutPrice").textContent = priceCheckout(cart);

    // sync compare-at total + savings badge after AJAX (initial values come from Liquid)
    const compareEl = document.querySelector("#miniCartFooterCompare");
    const savingsEl = document.querySelector("#miniCartFooterSavings");
    if (cartCompareTotal > checkoutPrice) {
        compareEl.textContent = price(cartCompareTotal);
        compareEl.style.display = "inline";
        const pctOff = Math.round((cartCompareTotal - checkoutPrice) / cartCompareTotal * 100);
        savingsEl.textContent = `${pctOff}% Off`;
        savingsEl.style.display = "inline-flex";
    } else {
        compareEl.style.display = "none";
        savingsEl.style.display = "none";
    }
}

// deactivate upsell and quantity changes while updating cart
function preventMultipleActions() {
    document.querySelectorAll('.miniCartBodyItemQuantity,.miniCartBodyItemUpgrade')?.forEach(el => el.style.pointerEvents = 'none');
}

// Add Upsell function
document.querySelectorAll('.miniCartUpsellItemWrapATC')?.forEach(function (element) {
    element.addEventListener("click", async function () {
        // get variant ID from dropdown selector
        const variantID = this.closest('.miniCartUpsellItem').dataset.variant;

        // add loading animation
        this.classList.add("loading");

        // create form data
        let formData = {
            items: [{
                quantity: 1,
                id: variantID,
            }]
        };

        // add product upsell
        await addProduct(formData);

        // remove loading animation
        this.classList.remove("loading");

        await openCart();
    });
});


// listen for protection plan switch
document.querySelector("#miniCartFooterUpsellTopSwitchInput")?.addEventListener("change", async function () {
    await openCart(true);
});

// close event
document.querySelector("#miniCart").addEventListener("close", function () {
    document.querySelector("body").classList.remove("noScroll");
});


// close cart function
function closeCart() {
    document.querySelector("#miniCart").close();
    document.querySelector("body").classList.remove("noScroll");
}

// open cart event listener
document.querySelectorAll(".openCart").forEach(function (element) {
    element.addEventListener("click", function (e) {
        e.preventDefault();
        openCart();
    });
});

//close cart event listener
document.querySelectorAll(".closeCart").forEach(function (element) {
    element.addEventListener("click", closeCart);
});
document.querySelector("#miniCart").addEventListener("click", function (e) {
    if (e.target === this) {
        closeCart();
    }
})

// check if we are adding a water bottle for free gift
const bottle = document.querySelector('#miniCart').classList.contains('bottle');

// checkout button loading
document.querySelector("#miniCartFooterCheckout").addEventListener("click", async function () {
    this.classList.add("loading");
    let variety30PackCount = 0;
    let variety30hasSubscription = false;

    // determine total number of premium-electrolyte-drink-mix
    let premiumElectrolyteDrinkMixCount = 0;
    let hasSubscription = false;
    cart.items.forEach(item => {
        if (window.giftCountsAsBox ? window.giftCountsAsBox(item) : item.handle === "premium-electrolyte-drink-mix") {
            premiumElectrolyteDrinkMixCount += item.quantity;
        }
        if (item.selling_plan_allocation) {
            hasSubscription = true;
        }
    });
    cart.items.forEach(item => {
        if (item.handle === "variety-pack-30ct" && item.selling_plan_allocation && window.enabledPack30) {
            variety30PackCount += item.quantity;
            variety30hasSubscription = true;
        }
    });
    // add all gifts if 4 or more items
    if (premiumElectrolyteDrinkMixCount >= 4) {
        const add = [];
        if (bottle) {
            add.push({
                id: waterBottleVariantID,
                quantity: 1,
                properties: {"_promo": "new subscription"}
            })
        }
        add.push({
            quantity: 1,
            id: samplerVariantID,
            properties: {"_promo": "new subscription"}
        })
        await addProduct({
            items: add
        });
    } else if (premiumElectrolyteDrinkMixCount >= 1 && hasSubscription) {
        // add a sampler pack if there is a subscription
        await addProduct({
            items: [{
                quantity: 1,
                id: samplerVariantID,
                properties: {"_promo": "new subscription"}
            }]
        });
    }else if (variety30PackCount >= 1 && variety30hasSubscription  && window.enabledPack30) {
        // add a sampler pack if there is a subscription
        await addProduct({
            items: [{
                quantity: 1,
                id: samplerVariantID,
                properties: {"_promo": "new subscription"}
            }]
        });
    }

    // remove loading animation
    this.classList.remove("loading");

    // go to checkout
    window.location.href = `${Shopify.routes.root}checkout`;
});

// check is coming from the cart
if (document.referrer.includes("/cart")) {
    openCart();
}

// Expose globally so ATC buttons in other files (theme-global.js, main-product.js, etc.) can call it
window.openCart = openCart;
window.closeCart = closeCart;

} // end A/B test guard
